import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import {combineReducers, createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';

import {App} from './App';

import {reducer as user} from './_reducers/user';
import {reducer as feedback} from './_reducers/feedback';
import {reducer as statusMessage} from './_reducers/statusMessage';
import {reducer as rtms} from './_reducers/rtms';
import {reducer as layout} from './_reducers/layout';

import {User} from './_services/User';
import {Flow, FlowFetchResponse} from './_services/Flow';
import {LoadingIndicator} from './components/LoadingIndicator';
import {userAuthenticated} from './_actions/user';

import {persistState, getPersistedState} from './_helpers/state';

Promise.prototype.finally = {
    finally (fn) {
        const onFinally = value => Promise.resolve(fn()).then(() => value);
        return this.then(
            result => onFinally(result),
            reason => onFinally(Promise.reject(reason))
        );
    }
}.finally;

const reducer = combineReducers({
    user,
    feedback,
    statusMessage,
    rtms,
    layout
});

// read state from localStorage
// {layout: {entryGutter: {comments: {display: 'minimized'}}}}
const initialStoreState = getPersistedState();
const store = createStore(reducer, initialStoreState, applyMiddleware(thunk));
const debounce = require('debounce-promise');
store.subscribe(
    debounce(() => {
        persistState(store.getState());
    }, 1000)
);

// on initial load, check to see if user is already authenticated
if (!User.getInstance().getAuthToken()) {
    Flow.getInstance().checkSession()
        .then((response: FlowFetchResponse) => {
            console.log(response);
            if (response.ok && response.json.token) {
                console.log('setting', response.json);
                User.getInstance().setAuthToken(response.json.token);
                User.getInstance().setEmail(response.json.user.email);
                User.getInstance().setRoles(response.json.user.roles);
                store.dispatch(userAuthenticated());
            }

            ReactDOM.render(
                <Provider store={store}>
                    <Router basename="/p/flow">
                        <App/>
                    </Router>
                </Provider>,
                document.getElementById('root')
            );
        })
        .catch((error: any) => {
            console.log(error);
            ReactDOM.render(
                <p className="text-danger">Unrecoverable error. Please reload page to try again</p>,
                document.getElementById('root')
            );
        });

    ReactDOM.render(
        <LoadingIndicator/>,
        document.getElementById('root')
    );
} else {
    ReactDOM.render(
        <Provider store={store}>
            <Router basename="/p/flow">
                <App/>
            </Router>
        </Provider>,
        document.getElementById('root')
    );
}